export const NUMBER_OF_ITEMS = 2;
export const WEIGHT = 3;
export const UKIMS_NUMBER = 32;
